module.exports = __webpack_public_path__ + "media/unipod/eight_step8-55055be5.jpg";